import { lazy } from "react";
import { Navigate, Route } from "react-router-dom";
import Protected from "@/components/Protected";

const PharmacyOrders         = lazy(() => import("@/pages/PharmacyOrders"));
const PharmacyVerification   = lazy(() => import("@/pages/PharmacyVerification"));
const PharmacyDispense       = lazy(() => import("@/pages/PharmacyDispense"));
const PharmacyFulfilmentPage = lazy(() => import("@/pages/PharmacyFulfilmentPage"));
const PharmacyDelivery       = lazy(() => import("@/pages/PharmacyDelivery"));
const PartnerNotificationPrefs = lazy(() => import("@/pages/PartnerNotificationPrefs"));
const PartnerAccount         = lazy(() => import("@/pages/partner/PartnerAccount"));
const PharmacySettlements    = lazy(() => import("@/pages/PharmacySettlements"));
const PharmacyDashboard      = lazy(() => import("@/pages/PharmacyDashboard"));

const P = ["pharmacy"];
const PL = ["pharmacy_staff", "pharmacy"]; // legacy dashboard also allows pharmacy_staff

export default (
  <>
    {/* Legacy landing */}
    <Route path="/pharmacy"              element={<Protected roles={PL}><PharmacyDashboard /></Protected>} />

    {/* Shell */}
    <Route path="/pharmacy/orders"       element={<Protected roles={P}><PharmacyOrders /></Protected>} />
    <Route path="/pharmacy/verification" element={<Protected roles={P}><PharmacyVerification /></Protected>} />
    <Route path="/pharmacy/dispense"     element={<Protected roles={P}><PharmacyDispense /></Protected>} />
    <Route path="/pharmacy/fulfilment"   element={<Protected roles={P}><PharmacyFulfilmentPage /></Protected>} />
    <Route path="/pharmacy/delivery"     element={<Protected roles={P}><PharmacyDelivery /></Protected>} />
    <Route path="/pharmacy/settlements"  element={<Protected roles={P}><PharmacySettlements /></Protected>} />
    <Route path="/partner/notifications" element={<Protected roles={["pharmacy", "laboratory"]}><PartnerNotificationPrefs /></Protected>} />
    <Route path="/partner/account"       element={<Protected roles={["pharmacy", "laboratory"]}><PartnerAccount /></Protected>} />

    {/* Legacy — Stock and Quotes have been merged into a single Dispense
        page (iter 109). Deep links continue to work via permanent redirects. */}
    <Route path="/pharmacy/stock"        element={<Navigate to="/pharmacy/dispense" replace />} />
    <Route path="/pharmacy/quotes"       element={<Navigate to="/pharmacy/dispense" replace />} />
  </>
);
